import "./AppointmentsCertificationAndConsentAddComponent.scss";
import BackComponent from "../../../../shared/components/back/BackComponent";
import CardComponent from "../../../../shared/components/card/CardComponent";
import React, {useCallback} from "react";
import ClientRegistrationCertificationAndConsentComponent
    from "../../../client-registration/client-registration-certification-and-consent/ClientRegistrationCertificationAndConsentComponent";
import {useParams} from "react-router-dom";

interface AppointmentsCertificationAndConsentAddComponentProps {

}

const AppointmentsCertificationAndConsentAddComponent = (props: AppointmentsCertificationAndConsentAddComponentProps) => {
    const params = useParams<{appointmentId:string}>();
    const {appointmentId} = params;
    const handleBackNavigation = useCallback(() => {
        window.history.back();
    }, []);

    return (
        <div className={'appointments-certification-and-consent-add-component appointment-form'}>
            <div className={'appointments-form-header'}>
                <BackComponent onClick={() => {
                    handleBackNavigation()
                }}/>
                {/*{appointmentDetails?.status === 'scheduled' && <>*/}
                {/*    <ButtonComponent onClick={handleRescheduleAppointment}>*/}
                {/*        Reschedule Appointment*/}
                {/*    </ButtonComponent>*/}
                {/*</>}*/}
            </div>
            <CardComponent>
                <ClientRegistrationCertificationAndConsentComponent mode={'add'}  onNext={handleBackNavigation} appointmentId={appointmentId}/>
            </CardComponent>
        </div>
    );

};

export default AppointmentsCertificationAndConsentAddComponent;
